import { Maybe } from 'maybe-not';
export function checkRequiredPermissionsOnPlatform(messageBus, requiredPermissions) {
    if (!requiredPermissions || requiredPermissions.length === 0) {
        return Promise.resolve(true);
    }
    return messageBus
        .sendRequest('canUser', Maybe.just(JSON.stringify({ capabilities: requiredPermissions })))
        .then(response => response.value.allowed);
}
//# sourceMappingURL=check-permissions.js.map